module.exports = __webpack_public_path__ + "media/CancelPkg.6474e58b.mp3";